var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormalAlign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.5H15.5V13.8333H0.5V15.5ZM0.5 12.1667H15.5V10.5H0.5V12.1667ZM0.5 8.83333H15.5V7.16667H0.5V8.83333ZM0.5 5.5H15.5V3.83333H0.5V5.5ZM0.5 0.5V2.16667H15.5V0.5H0.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalAlign);
export default __webpack_public_path__ + "static/media/normalAlign.bc1449855de1f68264f6378f9218e81f.svg";
export { ForwardRef as ReactComponent };